var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseDarkOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.683594,
    y: 0.664062,
    width: 68.6176,
    height: 68.6176,
    rx: 9.80251,
    fill: "#FCCDBA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1085_31730)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1085_31730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4007 22.382C23.1121 23.9872 19.6016 25.3167 19.6016 25.335C19.6016 25.3534 23.1182 26.6829 27.4129 28.2881L35.2243 31.2166L38.1467 30.1199L41.0752 29.0232L40.7382 28.8701C40.5544 28.7904 39.2372 28.2452 37.8097 27.657C35.3714 26.6584 35.2243 26.5849 35.3897 26.5175C35.4816 26.4807 36.37 26.107 37.3564 25.6843L39.1514 24.9184L42.08 26.2295L45.0146 27.5467L47.9308 26.4562C49.536 25.8558 50.8471 25.3534 50.8471 25.335C50.8471 25.3105 35.5123 19.5516 35.255 19.478C35.2243 19.4658 31.6832 20.7769 27.4007 22.382Z",
    fill: "#FF6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5552 36.1236L19.5736 44.952L26.8949 47.6967L34.2161 50.4414L34.2345 41.6437C34.2406 36.8037 34.2284 32.8275 34.2039 32.8091C34.1732 32.7846 31.0425 31.6022 27.2318 30.1747C23.4272 28.7472 20.1372 27.5158 19.9228 27.4423L19.543 27.2952L19.5552 36.1236ZM25.4245 42.1767L27.3543 42.8996L27.3727 43.9472C27.3789 44.5293 27.3789 45.001 27.3727 45.001C27.3605 45.001 26.4844 44.6763 25.4245 44.2719L23.4946 43.549L23.4762 42.5014C23.4701 41.9193 23.4701 41.4476 23.4762 41.4476C23.4885 41.4476 24.3646 41.7723 25.4245 42.1767Z",
    fill: "#FF6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.97 28.3982L45.0599 29.4887L45.0293 31.9577L44.9987 34.4206L43.0688 35.1436C42.0089 35.5479 41.1328 35.8726 41.1267 35.8726C41.1144 35.8726 41.1022 34.7698 41.096 33.4281L41.0777 30.9836L38.6577 31.8903L36.2377 32.7971L36.2193 41.6255L36.207 50.4539L36.5869 50.3068C36.8013 50.2333 40.0913 49.0019 43.8959 47.5744C47.7066 46.1469 50.8373 44.9644 50.8679 44.9399C50.8924 44.9216 50.9047 40.9454 50.8985 36.1054L50.8802 27.3077L47.97 28.3982Z",
    fill: "#FF6200"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1085_31730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.368,
    height: 31.368,
    fill: "white",
    transform: "translate(19.3086 19.2888)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1085_31730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.368,
    height: 31.368,
    fill: "white",
    transform: "translate(19.543 19.2693)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseDarkOrange);
export default __webpack_public_path__ + "static/media/case_dark_orange.cf713a950ea9a6c85eb14bb537d43dae.svg";
export { ForwardRef as ReactComponent };